export const approvalType = {
    required: 'required',
    total: 'total',
    optional: 'optional',
    available: 'available'
}